import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            探索内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按主题浏览开云登录的相关内容，快速找到您需要的信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/60 hover:shadow-sm transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100/80 flex-shrink-0 group-hover:bg-primary-200/70 transition-colors">
                  <i className={`${category.icon} text-lg text-primary-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {category.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {category.description}
                  </p>
                  <div className="flex items-center gap-1 mt-3 text-sm text-primary-500 font-medium">
                    <span className="whitespace-nowrap">浏览内容</span>
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}